/* ASR Hero — behaviour for sections/asr-hero.liquid (sizing, video, showcase). */
(function () {
function initAsrHero(root) {
  if (!root || root.dataset.asrInit) return;
  root.dataset.asrInit = '1';
  var desktop = window.matchMedia('(min-width: 750px)');
  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = navigator.connection && navigator.connection.saveData;
  var showcase = root.dataset.showcase === 'true';
  var strength = parseFloat(root.dataset.parallax) || 0;
  var tiles = Array.prototype.slice.call(root.querySelectorAll('.asr-tile'));
  var videos = [];

  function sizeHero() {
    if (root.dataset.height !== 'fill' || !desktop.matches) { root.style.removeProperty('--asr-hero-h'); return; }
    var grid = root.querySelector('.asr-hero__grid');
    var top = grid.getBoundingClientRect().top + window.scrollY;
    var min = parseInt(root.dataset.min, 10) || 600;
    root.style.setProperty('--asr-hero-h', Math.max(min, window.innerHeight - top) + 'px');
  }
  sizeHero();
  window.addEventListener('resize', sizeHero, { passive: true });
  window.addEventListener('load', sizeHero);

  /* Video: muted loop, only while its tile is showcased (or always when showcase is off). */
  tiles.forEach(function (tile) {
    var video = tile.querySelector('video');
    if (!video) return;
    var allowMobile = tile.dataset.videoMobile === 'true';
    if (reduce.matches || saveData || (!desktop.matches && !allowMobile)) return;
    if (!desktop.matches && allowMobile) video.style.display = 'block';
    video.muted = true;
    video.addEventListener('playing', function () { video.classList.add('is-playing'); tile.classList.add('is-ready'); }, { once: true });
    videos.push({ tile: tile, video: video });
    var btn = tile.querySelector('.asr-tile__pause');
    if (btn) btn.addEventListener('click', function () {
      if (video.paused) { delete video.dataset.userPaused; video.play(); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Pause background video'); btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" aria-hidden="true"><rect x="2" y="1" width="3.5" height="12"></rect><rect x="8.5" y="1" width="3.5" height="12"></rect></svg>'; }
      else { video.dataset.userPaused = '1'; video.pause(); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Play background video'); btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" aria-hidden="true"><path d="M3 1.5v11l9-5.5z"></path></svg>'; }
    });
  });
  function syncVideos() {
    videos.forEach(function (v) {
      var on = !showcase || v.tile.classList.contains('is-active');
      if (on && v.video.paused && !v.video.dataset.userPaused && !document.hidden) { var p = v.video.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!on && !v.video.paused) v.video.pause();
    });
  }
  syncVideos();
  window.addEventListener('load', syncVideos);
  document.addEventListener('visibilitychange', syncVideos);

  if (!showcase) return;

  /* Showcase: one tile in colour + zoom, the rest grayscale. */
  function setActive(tile) {
    tiles.forEach(function (t) {
      var on = t === tile;
      t.classList.toggle('is-active', on);
      if (!on) { t.style.removeProperty('--asr-px'); t.style.removeProperty('--asr-py'); }
    });
    syncVideos();
  }

  /* Desktop with a mouse: the hovered tile is showcased; leaving the hero greys everything.
     Hover intent: a tile only takes over once the cursor rests on it (40ms), so sweeping across doesn't flicker. */
  var intent = 0;
  function later(fn, ms) { clearTimeout(intent); intent = setTimeout(fn, ms); }
  tiles.forEach(function (tile) {
    tile.addEventListener('mouseenter', function () { if (desktop.matches && mouse.matches) later(function () { setActive(tile); }, 40); });
    tile.addEventListener('focusin', function () { clearTimeout(intent); setActive(tile); });
  });
  root.addEventListener('mouseleave', function () { if (desktop.matches && mouse.matches) later(function () { setActive(null); }, 100); });
  var raf = 0, mx = 0, my = 0;
  root.addEventListener('mousemove', function (e) {
    if (!strength || reduce.matches || !desktop.matches) return;
    mx = e.clientX; my = e.clientY;
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      var t = root.querySelector('.asr-tile.is-active');
      if (!t) return;
      var r = t.getBoundingClientRect();
      t.style.setProperty('--asr-px', (((mx - r.left) / r.width - 0.5) * strength).toFixed(2));
      t.style.setProperty('--asr-py', (((my - r.top) / r.height - 0.5) * strength).toFixed(2));
    });
  }, { passive: true });

  /* Phones (stacked tiles): the tile nearest the middle of the screen is showcased. */
  var sraf = 0;
  function byScroll() {
    sraf = 0;
    if (desktop.matches) return;
    var mid = window.innerHeight / 2, best = null, dist = Infinity;
    tiles.forEach(function (t) {
      var r = t.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var d = Math.abs(r.top + r.height / 2 - mid);
      if (d < dist) { dist = d; best = t; }
    });
    if (best && !best.classList.contains('is-active')) setActive(best);
  }
  window.addEventListener('scroll', function () { if (!sraf) sraf = requestAnimationFrame(byScroll); }, { passive: true });
  byScroll();
}
document.querySelectorAll('.asr-hero').forEach(initAsrHero);
/* Theme editor: re-init a section after it is re-rendered. */
document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.asr-hero').forEach(initAsrHero); });
})();